module.exports = __webpack_public_path__ + "media/error.605960b0.mp3";